(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sun-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnounce(root) {
      if (root.dataset.sunInit) return;
      root.dataset.sunInit = 'true';
      var msgs = root.querySelectorAll('[data-sun-announce-msg]');
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4000);
    }
    function initAll() {
      document.querySelectorAll('[data-sun-announce]').forEach(initAnnounce);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sun-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.sunHeroInit) return;
      root.dataset.sunHeroInit = 'true';
      var slides = Array.from(root.querySelectorAll('.sun-hero__slide'));
      var dots   = Array.from(root.querySelectorAll('.sun-hero__dot'));
      if (slides.length < 2) return;
      var current = 0;
      var timer   = null;
      var DELAY   = 5000;

      function goTo(n) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = ((n % slides.length) + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function startTimer() {
        clearInterval(timer);
        timer = setInterval(function () { goTo(current + 1); }, DELAY);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.sunDot, 10));
          startTimer();
        });
      });

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', startTimer);

      var touchX = null;
      root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var diff = touchX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) { goTo(current + (diff > 0 ? 1 : -1)); startTimer(); }
        touchX = null;
      });

      startTimer();
    }

    function initAll() {
      document.querySelectorAll('[data-sun-hero]').forEach(initHero);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector('[data-sun-hero]');
      if (el) { el.removeAttribute('data-sun-hero-init'); initHero(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sun-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COOKIE = 'sun_popup_dismissed';
    var DELAY  = 3000;

    function getCookie(name) {
      var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return m ? m.pop() : '';
    }
    function setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
    }

    function init() {
      if (getCookie(COOKIE)) return;

      var overlay = document.getElementById('sun-popup-overlay');
      if (!overlay) return;

      // Show after delay
      var t = setTimeout(function () {
        overlay.classList.add('is-open');
        overlay.removeAttribute('aria-hidden');
      }, DELAY);

      function close() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        setCookie(COOKIE, '1', 30);
      }

      // Close buttons
      overlay.querySelectorAll('[data-sun-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });

      // Close on backdrop click
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      // Form submit — AJAX to Shopify newsletter
      var form = overlay.querySelector('[data-sun-popup-emailform]');
      var success = overlay.querySelector('[data-sun-popup-success]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.querySelector('input[type="email"]').value;
          if (!email) return;

          var body = new URLSearchParams();
          body.append('form_type', 'customer');
          body.append('utf8', '✓');
          body.append('contact[email]', email);
          body.append('contact[tags]', 'newsletter, popup');

          fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
          }).then(function () {
            form.style.display = 'none';
            if (success) success.hidden = false;
            setCookie(COOKIE, '1', 30);
            setTimeout(close, 2500);
          }).catch(function () {
            if (success) success.hidden = false;
            setTimeout(close, 2500);
          });
        });
      }
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sun-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.sunInit) return;
      root.dataset.sunInit = 'true';
      var track = root.querySelector('[data-sun-track]');
      var prev = root.querySelector('[data-sun-prev]');
      var next = root.querySelector('[data-sun-next]');
      if (!track) return;
      function step(dir) {
        var card = track.querySelector('.sun-card');
        var amount = card ? card.getBoundingClientRect().width * 2 : track.clientWidth * 0.5;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    }
    function initAll() {
      document.querySelectorAll('[data-sun-carousel]').forEach(initCarousel);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sun-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVid(section) {
      var vid = section.querySelector('video');
      if (!vid) return;
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { vid.play(); } else { vid.pause(); }
        });
      }, { threshold: 0.2 });
      obs.observe(section);
    }
    function initAll() {
      document.querySelectorAll('[data-sun-vidsec]').forEach(initVid);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector('[data-sun-vidsec]');
      if (el) initVid(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
